<div class="w-100-p" *ngIf="dataSource">
    <mat-table #table [dataSource]="dataSource" matSort matSortActive="{{ sortBy }}" matSortDirection="{{ sortOrder }}">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="checkbox">
            <mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? toggle.emit(isAllSelected) : null"
                    [checked]="selectedUserIds.length && isAllSelected"
                    [indeterminate]="selectedUserIds.length && !isAllSelected"
                >
                </mat-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let experienceUser">
                <mat-checkbox [(ngModel)]="checkboxes[experienceUser.id]" (ngModelChange)="select.emit(experienceUser)" (click)="$event.stopPropagation()"> </mat-checkbox>
            </mat-cell>
        </ng-container>

        <!-- Avatar Column -->
        <ng-container matColumnDef="avatar">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let experienceUser">
                <div class="relative" #avatarCell>
                    <img
                        class="avatar pointer"
                        *ngIf="experienceUser?.user?.avatar.src; else initials"
                        [alt]="experienceUser?.user?.fullName"
                        [src]="experienceUser?.user?.avatar.src"
                    />
                    <ng-template #initials>
                        <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ experienceUser?.user?.fullName | initials }}</div>
                    </ng-template>
                    <ng-template [onlineStateIndicator]="experienceUser.user?.isOnline"> </ng-template>
                </div>
            </mat-cell>
        </ng-container>

        <!-- First Name Column -->
        <ng-container matColumnDef="firstName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.FIRST_NAME' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let experienceUser">
                <a *ngIf="experienceUser?.user" class="text-truncate font-semibold" [routerLink]="['/users/' + experienceUser?.user?.id + '/edit']">{{
                    experienceUser?.user?.firstName
                }}</a>
            </mat-cell>
        </ng-container>

        <!-- Last Name Column -->
        <ng-container matColumnDef="lastName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.LAST_NAME' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let experienceUser">
                <a *ngIf="experienceUser?.user" class="text-truncate font-semibold" [routerLink]="['/users/' + experienceUser?.user?.id + '/edit']">{{
                    experienceUser?.user?.lastName
                }}</a>
            </mat-cell>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm> {{ 'GENERAL.PROPERTY.EMAIL' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let experienceUser" fxHide fxShow.gt-sm>
                <a *ngIf="experienceUser?.user" [href]="'mailto:' + experienceUser?.user?.email" target="_top">{{ experienceUser?.user?.email }}</a>
            </mat-cell>
        </ng-container>

        <!-- Buttons Column -->
        <ng-container matColumnDef="buttons">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let experienceUser; let i = index">
                <div fxFlex="row" fxLayoutAlign="end center mr-4">
                    <button mat-icon-button aria-label="download" (click)="moveExperienceUser(experienceUser.id)">
                        <mat-icon class="mat-icon-more-vert">drive_file_move</mat-icon>
                    </button>
                    <button mat-icon-button aria-label="delete" (click)="deleteExperienceUser(experienceUser.id)">
                        <mat-icon class="mat-icon-more-vert">delete</mat-icon>
                    </button>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let experienceUser; columns: displayedColumns" class="user" [ngClass]="{ 'accent-50': checkboxes[experienceUser.id] }" matRipple> </mat-row>
    </mat-table>

    <mat-paginator persistPageSize="grow.experience-users-list" [length]="totalCount$ | async" [pageSize]="10" [pageSizeOptions]="[10, 25, 50]"></mat-paginator>
</div>
